import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { RouteModel, CustomerModel } from '@app/shared/models/route-allocation.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DeliveryType, RecurringType } from '@core/enums';
import { CustomerDropDownData } from '@app/shared/customer-dropdown.model';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { DeliveryService } from '@app/@core/services/delivery.service';
import moment from 'moment';
import { DateHelpers } from '@core/utils/date';
import { LaddaService } from '@app/@core/services/ladda.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../confirmation-dialog/confirm-dialog.component';
import { RouteService } from '@app/@core/services/route.service';
@Component({
  selector: 'add-customer-to-route-dialog',
  templateUrl: './add-customer-to-route-dialog.component.html',
  styleUrls: ['./add-customer-to-route-dialog.component.scss'],
  standalone: false
})
export class AddCustomerToRouteDialogComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() data: RouteModel;
  @Input() customer: CustomerModel;
  @Input() isAddCustomer: boolean;
  @Input() selectedDate: moment.Moment;
  @Input() fromDateFilter: moment.Moment;
  @Input() toDateFilter: moment.Moment;
  @Input() currentIndex: any;
  @Output() isClosed = new EventEmitter<boolean>(false);
  @Output() isAdded = new EventEmitter<number>();
  @Output() isUpdated = new EventEmitter<boolean>(false);

  customerDropDownData = new CustomerDropDownData();
  DeliveryTypeEnum = DeliveryType;
  RecurringTypeEnum = RecurringType;

  mainForm: FormGroup;

  isLoading = false;
  private laddDaSubscription: Subscription;
  constructor(
    protected ref: NbDialogRef<AddCustomerToRouteDialogComponent>,
    private deliveryService: DeliveryService,
    private toastrService: NbToastrService,
    private laddaService: LaddaService,
    private router: Router,
    private dialogService: NbDialogService,
    private routeService: RouteService

  ) {

  }

  ngOnInit() {
    this.mainForm = new FormGroup({
      deliveryType: new FormControl(this.customer ? this.customer.deliveryType : null, Validators.compose([Validators.required])),
      recurringType: new FormControl(this.customer ? this.customer.recurringType : null),
      weekOfMonth: new FormControl(this.customer ? this.customer.weekOfMonth : null),
    });

    this.laddDaSubscription = this.laddaService.laddaState.subscribe(value => {
      this.isLoading = value.show;
    });
  }

  cancel() {
    this.isClosed.emit(true);
  }

  save() {


    this.isLoading = true;
    const formData = this.mainForm.getRawValue();
    this.data.deliveryType = formData.deliveryType;
    if (formData.deliveryType === this.DeliveryTypeEnum.Recurring) {
      this.data.recurringType = formData.recurringType;
      this.data.weekOfMonth = formData.weekOfMonth;
    }

    if (formData.deliveryType === this.DeliveryTypeEnum.CallIn) {
      this.customer.startDate = this.customer.endDate = this.selectedDate;
    } else {
      this.customer.startDate = this.customer.startDate || DateHelpers.getDayOfWeek(this.data.routeDay);
      this.customer.endDate = this.data.routeEndDate;
    }
    if (this.isAddCustomer) {
      this.customer.order = this.keepDigits((new Date()).getTime(), 2, 10);// Get Max unique other
      if (this.data.deliveries.find(x => x.id === this.customer.id)) {
        this.addDelivery();
        return;
      }
      this.ref.close();
      this.addDelivery();
    } else {
      this.deliveryService.updateDelivery(
        this.data,
        this.customer,
        this.fromDateFilter,
        this.toDateFilter,
        this.selectedDate,
      ).subscribe(r => {
        this.toastrService.success('', `Customer has been successfully updated.`);
        this.isLoading = false;
        this.isUpdated.emit(true);
      }, err => {
        this.isLoading = false;
      });
    }
  }

  keepDigits(num: number, start: number, count: number = 7) {
    const str = String(num);
    return Number(str.slice(start, count));
  }

  isInvalid() {

    if (!this.mainForm.controls['deliveryType'].value) {
      return true;
    } else if (this.mainForm.controls['deliveryType'].value === this.DeliveryTypeEnum.Recurring) {
      if (!this.mainForm.controls['recurringType'].value) {
        return true;
      } else if (this.mainForm.controls['recurringType'].value === this.RecurringTypeEnum.Monthly
        && !this.mainForm.controls['weekOfMonth'].value) {
        return true;
      }
    }
    return false;
  }

  ngOnDestroy() {
    this.laddDaSubscription.unsubscribe();
  }

  customerDetail() {
    this.isClosed.emit(true);
    this.router.navigateByUrl(`/pages/customers/edit/${this.customer.id}`);
  }

  isAllowAdd() {
    let result = true;
    if (this.data.isStartedToday) {
      if (!this.isAddCustomer || this.mainForm.controls['deliveryType'].value === this.DeliveryTypeEnum.Recurring) {
        result = false;
      }
    }
    return result;
  }

  addDelivery() {
    this.deliveryService.addDelivery(
      this.data,
      this.customer,
      this.fromDateFilter,
      this.toDateFilter,
      this.selectedDate,
    ).subscribe(r => {
      this.isLoading = false;
      this.toastrService.success('', `Customer has been successfully added.`);
      if (this.currentIndex) {
        const newDelivery = new CustomerModel();
        newDelivery.deliveryId = 0;
        this.data.deliveries.splice(this.currentIndex, 0, newDelivery);
        this.deliveryService.updateDeliveryOrder(this.data, this.selectedDate).subscribe(
          (u) => {
          },
        );
      }
      this.isAdded.emit(this.data.routeId);
    }, err => {
      this.isLoading = false;
    });
  }
}
